var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.43992 0.705078C1.38932 0.705078 0.535156 1.56458 0.535156 2.62174V12.2051C0.535156 13.2622 1.38932 14.1217 2.43992 14.1217H11.9637C13.0143 14.1217 13.8685 13.2622 13.8685 12.2051V4.93672C13.8685 4.4276 13.6691 3.93945 13.3119 3.58008L11.0113 1.2651C10.6542 0.905729 10.1691 0.705078 9.66313 0.705078H2.43992ZM2.43992 3.58008C2.43992 3.05 2.86551 2.62174 3.3923 2.62174H9.10659C9.63337 2.62174 10.059 3.05 10.059 3.58008V5.49675C10.059 6.02682 9.63337 6.45508 9.10659 6.45508H3.3923C2.86551 6.45508 2.43992 6.02682 2.43992 5.49675V3.58008ZM7.20182 12.2051C6.15123 12.2051 5.29706 11.3456 5.29706 10.2884C5.29706 9.23125 6.15123 8.37175 7.20182 8.37175C8.25242 8.37175 9.10659 9.23125 9.10659 10.2884C9.10659 11.3456 8.25242 12.2051 7.20182 12.2051Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.497c475b4d211ff0afea87373b87f42f.svg";
export { ForwardRef as ReactComponent };